"use strict";

exports.__esModule = true;
exports.AnyAccessCheck = void 0;
var _react = _interopRequireDefault(require("react"));
var _AccessCheck = require("../AccessCheck");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Render-prop powered Access Check
 */

var AnyAccessCheck = exports.AnyAccessCheck = function AnyAccessCheck(_ref) {
  var permissions = _ref.permissions,
    featureFlags = _ref.featureFlags,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_AccessCheck.AccessCheck, {
    featureFlags: featureFlags,
    permission: permissions
  }, function (_ref2) {
    var isAllowed = _ref2.isAllowed;
    return children({
      isAllowed: isAllowed
    });
  });
};